import type { CameraMode, PlayerId, Viewpoint } from './types'

export interface DeepLinkState {
  viewId?: string
  mode?: CameraMode
  playerId?: PlayerId
  journeyId?: string
}

export function parseDeepLink(search = window.location.search): DeepLinkState {
  const params = new URLSearchParams(search)
  const viewId = params.get('view') ?? params.get('at') ?? undefined
  const modeRaw = params.get('mode')
  const mode =
    modeRaw === 'explore' ||
    modeRaw === 'walk' ||
    modeRaw === 'trail' ||
    modeRaw === 'flight'
      ? modeRaw
      : undefined
  const playerRaw = params.get('player')
  const playerId =
    playerRaw === 'backpacker' ||
    playerRaw === 'couple' ||
    playerRaw === 'family' ||
    playerRaw === 'group'
      ? playerRaw
      : undefined
  const journeyId = params.get('journey') ?? undefined
  return { viewId, mode, playerId, journeyId }
}

export function writeDeepLink(state: DeepLinkState): void {
  const params = new URLSearchParams(window.location.search)
  if (state.viewId) params.set('view', state.viewId)
  else params.delete('view')
  params.delete('at')
  if (state.mode && state.mode !== 'explore') params.set('mode', state.mode)
  else params.delete('mode')
  if (state.playerId) params.set('player', state.playerId)
  if (state.journeyId) params.set('journey', state.journeyId)
  const qs = params.toString()
  const url = `${window.location.pathname}${qs ? `?${qs}` : ''}${window.location.hash}`
  history.replaceState(null, '', url)
}

export function shareViewpointUrl(viewpoint: Viewpoint): string {
  const url = new URL(window.location.href)
  url.searchParams.set('view', viewpoint.id)
  url.searchParams.delete('at')
  url.searchParams.delete('mode')
  return url.toString()
}
